import { Injector } from "@angular/core";
import { AutoUploadNode } from "../../AutoUploadNode";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { ROAEntity } from "../../../Data/MedicinalProductData/ROAEntity";
import { BaseNode } from "../../BaseNode";
import { TreeNodeRoutesOfAdministrationList } from "../../Art57Node/ListEntity/TreeNodeRoutesOfAdministrationList";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { environment } from "../../../../../../environments/environment";


export class ROAAutoUploadEntity extends AutoUploadNode {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any, useHist: boolean, disableAutoUpload:boolean, cloningNode: boolean) {
        const createChildTemplateparams = {nodeType:2};
        super(injector, labelTemplate, ROAEntity, useHist ? AutoUploadEntityEnum.roaHist : AutoUploadEntityEnum.roa, ServiceEnum.MedicinalProducts, parent, model,TreeNodeRoutesOfAdministrationList,false,disableAutoUpload,cloningNode,createChildTemplateparams);
        this.labelNodeName = 'Route of Administration';
        this.useHist = useHist;
    }

    public getListItem(): any[] {
        return [this.data.model.name_Admroute];
    }    

    override cloneNode(newParent: BaseNode): BaseNode {
      const labelTemplate = this.labelTemplate;
      let clonedNode: ROAAutoUploadEntity = new ROAAutoUploadEntity(this.ioc!, `${labelTemplate}`,newParent,this.data.model,false, this.isLoaded, true);      
      clonedNode.loadEntity();
      clonedNode.isLoading = false;

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

      clonedNode.cloningNode = false;
      return clonedNode;
    }

}